import { render } from "./voiceswiper.vue?vue&type=template&id=02fa612e&scoped=true"
import script from "./voiceswiper.vue?vue&type=script&lang=js"
export * from "./voiceswiper.vue?vue&type=script&lang=js"

import "./voiceswiper.vue?vue&type=style&index=0&id=02fa612e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fa612e"],['__file',"src/js/components/voiceswiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02fa612e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02fa612e', __exports__)) {
    api.reload('02fa612e', __exports__)
  }
  
  module.hot.accept("./voiceswiper.vue?vue&type=template&id=02fa612e&scoped=true", () => {
    api.rerender('02fa612e', render)
  })

}


export default __exports__